import React, { useState, useEffect, useRef, useContext } from 'react';
import { coreAxios } from "utilities/axios";
import { classNames } from 'primereact/utils';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { FileUpload } from 'primereact/fileupload';
import { Rating } from 'primereact/rating';
import { Toolbar } from 'primereact/toolbar';
import { InputTextarea } from 'primereact/inputtextarea';
import { RadioButton } from 'primereact/radiobutton';
import { InputNumber } from 'primereact/inputnumber';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { FiEdit } from "react-icons/fi";
import { CommonButton } from "components/Buttons/Buttons";
import { MasterButton } from "components/Buttons/MasterButton";
import  DeleteModalTwo  from "components/Modal/DeleteModalTwo";


//NEW
import { InputField } from "components/InputField/Input";
import { ConfirmPopup } from 'primereact/confirmpopup'; // To use <ConfirmPopup> tag
import { confirmPopup } from 'primereact/confirmpopup'; // To use confirmPopup method
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { GetRequisitionItems, DeleteRequisitionItem } from 'services/requisition/requisition.service';
import { AddReturn, GetReturns, DeleteReturn, UpdateReturn, DeleteReturnItem, GetReturnItems } from 'services/return/return.service';
import { GetChalanNames } from 'services/dropdown/dropdown.service';
import { GetStocksForSale } from 'services/stock/stock.service';
import { GetBrands } from "services/other/brand.service";
import { RequisitionTableForm } from 'components/Table/RequisitionTableForm';
import { ReturnRowExpansionTable } from 'components/Table/RowExpansionTable/ReturnRowExpansionTable';
import { NameColumn, TextColumn } from 'components/Table/ColumnTemplates/CustomColumn';
import { ReturnValidationSchema } from 'utilities/ValidationSchema/Return/ReturnValidationSchema';
import useProductDataTable from './hook/useProductDataTable';
const BASE_URL = process.env.REACT_APP_MAIN_URL


const ReturnToSupplier = () => {

    const { returnList, returnListLoading } = useSelector((state) => state.returnList);
    const { returnUpdate } = useSelector((state) => state.returnUpdate);
    const { returnAdd } = useSelector((state) => state.returnAdd);
    const { returnItems, returnItemsLoading} = useSelector((state) => state.returnItems);


    const [autoRequisitionTypeFilteredValue, setAutoRequisitionTypeFilteredValue] = useState([]);
    const [deleteProductID, setDeleteProductID] = useState();
    const [showDeleteProductModal, setShowDeleteProductModal] = useState(false);
    const [date, setDate] =useState(new Date());

    const { chalanNames } = useSelector((state) => state.chalanNames);
    const { stockList, stockListLoading } = useSelector((state) => state.stockListForSale);
    const { brandList } = useSelector((state) => state.brandList);


    const [showForm, setShowForm] = useState(false); //* state for form modal
    const [updateData, setUpdateData] = useState(null); // * state for update data


    // * intitial value for create division state
    const createInitialValue = {
        id: 0,
        chalan: "",
        return_date: date,
        return_items: [
            {
                id: 0,
                stock: "",
                brand: "",
                stock_quantity: "",
                return_quantity: "",
                reason: "",
            },
        ],
    };

    const updateInitialValue = {
        id: updateData?.id,
        chalan: chalanNames?.find((value) => value.id === updateData?.chalan) || "",
        return_date: new Date(updateData?.return_date),
        return_items: returnItems?.map((value) => {

            return {
                ...value,
                stock: stockList?.find((item) => item.id === value.stock),
                brand: brandList?.find((item) => item.id === value.brand),
            };
        }) || [
            {
                id: 0,
                stock: "",
                stock_quantity: 0,
                return_quantity: 0,
                reason: "",
            },
        ],

    };

    const formik = useFormik({
        initialValues: updateData ? updateInitialValue : createInitialValue, // * if state is update then updateData state value will show up
        validationSchema: ReturnValidationSchema, // * yup schema validation
        onSubmit: (values) => {

            const modifiedData = {
                ...values,
                chalan: values?.chalan?.id || 0,
                return_items: values.return_items.map((value) => {
                    return{
                        ...value,
                        stock: value.stock?.id,
                        brand: value.brand?.id,
                    }
                })
            };
            handelSubmit(modifiedData);
        },
        enableReinitialize: true,
    });

    const { modalTableColumns, modalTableActionButton } = useProductDataTable(
        updateData,
        formik, 
        setDeleteProductID, 
        setShowDeleteProductModal, 
        setShowForm, 
        setUpdateData,
    );


    const [selectedData, setSelectedData] = useState([])
    const dispatch = useDispatch();


    const updateReturn = (return_) => {
        setShowForm(true); // * set the form to true
        dispatch(GetReturnItems(return_?.id))
        setUpdateData(return_);
    };

    // delete 1
    const toast = useRef(null);

    const DeleteModal =  (event, id) => {

        confirmPopup({
            target: event.currentTarget,
            message: 'Do you want to delete this record?',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            accept: async () => {
                await dispatch(DeleteReturn(id))
                await toast.current.show({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
                await dispatch(GetReturns());
            },
            reject: () => {
                toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
            }
        });
    };

    const confirmDeleteProductDetail = async () => {
        const { id, return_instance } = deleteProductID;
        await dispatch(DeleteReturnItem(id));
        setShowDeleteProductModal(false);
        await dispatch(GetReturnItems(return_instance));
    };

    // form submit handler
    const handelSubmit = async (data) => {

        if(updateData){
            await dispatch(UpdateReturn(data)).then(() => {
                hideModal();
            });
            return
        }
        await dispatch(AddReturn(data)).then(() => {
            hideModal();
            return
        });
    };


    // modal hide function
    const hideModal = () => {
        setUpdateData(null); // * set updateData state to null to get latest update after when press again
        resetForm(); // * reset the form state
        setShowForm(false); // * close the form
    };

    // reset form function
    const resetForm = () => {
        formik.resetForm();
    };

    useEffect(() => {
        dispatch(GetReturns());
        dispatch(GetChalanNames());
        dispatch(GetStocksForSale());
        dispatch(GetBrands())
    }, [returnAdd, returnUpdate]);


    // columns of the table with header name
    const tableColumns = [
        { field: "chalan_name", header: "Chalan", sortableBody: NameColumn },
        { field: "date", header: "Return Date", sortableBody: TextColumn },
    ];

    const searchRequsitionType = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && chalanNames !== undefined) {
                setAutoRequisitionTypeFilteredValue([...chalanNames]);
            } else {
                setAutoRequisitionTypeFilteredValue(
                    chalanNames?.filter((chalan) => {
                        return chalan.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    const downloadRequisition = async (rowData) => {
        const url = `${BASE_URL}/api/return/download/${rowData.id}/`;
        try {
            const response = await coreAxios.get(url, {
              responseType: 'blob',
            });
            const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', `return-${rowData.name}.pdf`);
            document.body.appendChild(link);
            link.click();
        } catch(error){
          console.log(error)
        }
    };


    // * input data array of object for the form / modal
    const inputData = [
        {
            id: "chalan",
            name: "chalan",
            type: "select",
            labelFor: "Chalan",
            label: "Select Chalan",
            required: true,
            className: "col-12 md:col-3",
            autoFilteredValue: autoRequisitionTypeFilteredValue,
            autoCompleteMethod: searchRequsitionType,
            selectedAutoValue: chalanNames,
            disabled: updateData ? true : false,
        },
        {
            id: "return_date",
            name: "return_date",
            value: "return_date",
            type: "date",
            labelFor: "Return Date",
            label: "Return Date",
            required: false,
            messagePosition: 'bottom',
            className: "col-12 md:col-3",
        },
    ];

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <div className="actions">
                    <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => updateReturn(rowData)} />
                    <Toast ref={toast} />
                    <ConfirmPopup />
                    <Button 
                        onClick={(e) => {
                            DeleteModal(e, rowData.id);
                        }} 
                        icon="pi pi-trash" 
                        className="p-button-rounded p-button-warning mr-2"
                        // disabled= {rowData.work_order_status === true ? true : false}
                    />
                    <Button 
                        icon="pi pi-download" 
                        className="p-button-rounded p-button-secondary" 
                        onClick={(e) => {
                            downloadRequisition(rowData)
                        }}
                    />
                </div>
            </>
        );
    }

    return (
        <>
            <ReturnRowExpansionTable
                //data
                tableHeaderName="Return Details"
                tableColumns={tableColumns}
                data={returnList}
                loading={returnListLoading}
                dataKey="id"
                rows={25}
                sortable
                searchField
                isRowSelectable
                exportBtn
                selectedData = {selectedData}
                setSelectedData = {setSelectedData}
                actionButton={actionBodyTemplate}
                setShowCreateModal={setShowForm}
            />
            <Dialog 
                visible={showForm} 
                style={{ width: "1400px" }} 
                header={`${updateData ? "Update" : "Create"} Return`} 
                className="p-fluid" 
                onHide={hideModal} 
                modal closeOnEscape blockScroll icons focusOnShow resizable maximizable
            >
                <form onSubmit={formik.handleSubmit} className={`grid grid-cols-4 mt-2 gap-x-3`}>
                    {inputData.map(({ id, name, value, type, labelFor, label, required, rows, className, autoCompleteMethod, autoFilteredValue, onBlur, onChange, errors, ...rest }) => (
                            
                        <div key={id} className={`p-field ${className}`} >
                            <InputField
                                id={id}
                                type={type}
                                required={required}
                                name={name}
                                errors={errors || formik.errors?.[id]?.id || formik.errors[id]}
                                label={label}
                                labelFor={labelFor}
                                rows={rows}
                                value={formik.values[name]}
                                autoCompleteMethod={autoCompleteMethod}
                                autoFilteredValue={autoFilteredValue}
                                onChange={(...args) => {
                                    !onChange && formik.handleChange(...args);
                                    onChange?.(...args);
                                }}
                                onBlur={onBlur}
                                onClose={() => formik.setErrors({})}
                                {...rest}
                            />
                        </div>
                    ))}

                    <div className="col-12">
                        <div className="w-full">
                            <RequisitionTableForm
                                emptyMessage="No data found"
                                tableColumns={modalTableColumns}
                                data={formik.values.return_items}
                                loading={stockListLoading}
                                dataKey="productID"
                                actionButtonWidth={10}
                                actionButton={modalTableActionButton}
                            />
                        </div>
                    </div>
                    
                    <MasterButton resetForm={resetForm} update={updateData} loading={stockListLoading} col1={8} col2={updateData ? 6 : 7} col3={4}/>
                    <DeleteModalTwo
                        visibleModal={showDeleteProductModal}
                        header="Confirm"
                        onHide={() => setShowDeleteProductModal(false)}
                        multiItem={false}
                        confirmDelete={confirmDeleteProductDetail}
                        item={deleteProductID}
                        loading={returnItemsLoading}
                        message="Are you sure you want to delete this item? This Cannot be undone!"
                    />
                </form>
            </Dialog>
        </>
    );
};

export default ReturnToSupplier;
